import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(date) {
  return new Date(date).toLocaleDateString('pt-PT', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}

export function calculateProgress(objectives) {
  if (!objectives || objectives.length === 0) return 0;
  const completed = objectives.filter(obj => obj.completed).length;
  return Math.round((completed / objectives.length) * 100);
}

export function getStatusColor(completed) {
  return completed ? 'success' : 'muted';
}

// Função para converter valores com vírgula para número
export function parseDecimal(value) {
  if (value === '' || value === null || value === undefined) {
    return 0;
  }
  
  // Converte para string se não for
  const stringValue = String(value);
  
  // Substitui vírgula por ponto
  const normalized = stringValue.replace(',', '.');
  
  // Parse para float
  const parsed = parseFloat(normalized);
  
  // Retorna 0 se for NaN, senão retorna o valor parseado
  return isNaN(parsed) ? 0 : parsed;
}

// Função para formatar número para exibição com vírgula
export function formatDecimal(value) {
  if (value === '' || value === null || value === undefined) {
    return '';
  }
  
  return String(value).replace('.', ',');
}
